export default __webpack_public_path__ + "static/media/EI1-1.3a740557.jpg";